import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { InstanceService } from 'src/app/service/instance.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser'

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})

export class TemplateComponent implements OnInit {
  html: SafeHtml;

  constructor(
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private instanceService : InstanceService,
    private sanitizer: DomSanitizer
    ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let htmlReturn = "";
      var processId = params["processId"] + "";
      var attributes : AttributeModel = {key : "Codigo TUSS" , type : "ColletionMultiple", value : params["procedimentos"], options: []};
      this.instanceService
        .getFilter(processId,"print","Filtro de procedimentos",[attributes])
        .subscribe((attributeModel : AttributeModel[]) => {

      let returnAttributes = attributeModel.find(attr =>attr.key.toLowerCase() == "print").attributes;
          returnAttributes.forEach((attr) =>{
            htmlReturn += attr.value;
          })
          this.html = this.sanitizer.bypassSecurityTrustHtml( htmlReturn);
        });
    });
  }


}

